/*
 * Copyright 2025 The Backstage Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

import { Entity } from '@backstage/catalog-model';
import { KNATIVE_SERVICE_ANNOTATION } from '../types';

/**
 * Check if Knative Service is available for this entity.
 * Returns true if the entity has the knative.dev/service-name annotation.
 *
 * @param entity - The Backstage entity to check
 * @returns true if Knative Service is available
 *
 * @public
 */
export function isKnativeServiceAvailable(entity: Entity): boolean {
  return Boolean(entity.metadata.annotations?.[KNATIVE_SERVICE_ANNOTATION]);
}

